import { render, staticRenderFns } from "./AzMoneyLicitacao.vue?vue&type=template&id=1a1e39ab&"
import script from "./AzMoneyLicitacao.vue?vue&type=script&lang=js&"
export * from "./AzMoneyLicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports